/**
 * WhatsAppBusinessConfig — Configuração específica do provider whatsapp-business (Cloud API).
 *
 * Diferente do gateway: não tem QR/engine, apenas exibe os limites de envio
 * (com daily gerenciado pela Meta).
 */
import React from 'react';
import type { ChannelResponse } from '@/modules/channels/types';
import { RateLimitsCard } from './RateLimitsCard';

interface WhatsAppBusinessConfigProps {
  channel: ChannelResponse;
}

export const WhatsAppBusinessConfig: React.FC<WhatsAppBusinessConfigProps> = ({ channel }) => {
  return (
    <div className="space-y-4">
      <RateLimitsCard channelId={channel.id} />
    </div>
  );
};

WhatsAppBusinessConfig.displayName = 'WhatsAppBusinessConfig';
